import React from "react";
import { Link } from "react-scroll";
import { Twitter, Instagram, Facebook } from "lucide-react";

const Footer = () => {
    return (
        <footer className="bg-gray-800 text-white py-12">
            <div className="container mx-auto px-6">
                {/* Top grid */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    {/* Brand */}
                    <div>
                        <h3 className="text-2xl font-bold text-[#2148C0] mb-4">TeeChaa</h3>
                        <p className="text-gray-400 leading-relaxed">
                            Empowering Nigerian students to achieve academic excellence
                            through innovative learning solutions.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
                        <ul className="space-y-2">
                            <li>
                                <Link
                                    to="home"
                                    smooth={true}
                                    className="text-gray-400 hover:text-white cursor-pointer"
                                >
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="about"
                                    smooth={true}
                                    className="text-gray-400 hover:text-white cursor-pointer"
                                >
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="features"
                                    smooth={true}
                                    className="text-gray-400 hover:text-white cursor-pointer"
                                >
                                    Features
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="subjects"
                                    smooth={true}
                                    className="text-gray-400 hover:text-white cursor-pointer"
                                >
                                    Subjects
                                </Link>
                            </li>
                        </ul>
                    </div>
                    
                    {/* Support */}
                    <div>
                        <h4 className="text-lg font-semibold mb-4">Support</h4>
                        <ul className="space-y-2">
                            <li>
                                <a href="#" className="text-gray-400 hover:text-white">
                                    Help Center
                                </a>
                            </li>
                            <li>
                                <a href="#" className="text-gray-400 hover:text-white">
                                    Contact Us
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/privacy-policy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-400 hover:text-white"
                                >
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/terms-of-service"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-gray-400 hover:text-white"
                                >
                                    Terms of Service
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Connect */}
                    <div>
                        <h4 className="text-lg font-semibold mb-4">Connect</h4>
                        <div className="flex space-x-4">
                            {/* X / Twitter */}
                            <a
                                href="https://x.com/teecha_ed?s=11&t=RouG13i5_jrAV2W5TQaZsw"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-blue-400 rounded-full flex items-center justify-center hover:bg-blue-500 cursor-pointer transition-colors"
                            >
                                <Twitter className="w-5 h-5 text-white" />
                            </a>

                            {/* Instagram */}
                            <a
                                href="https://www.instagram.com/teechaa.ed?igsh=bGh2aXljaWc4YjNk&utm_source=qr"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 cursor-pointer transition-colors"
                            >
                                <Instagram className="w-5 h-5 text-white" />
                            </a>

                            {/* TikTok */}
                            <a
                                href="https://www.tiktok.com/@teecha.edu"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-black rounded-full flex items-center justify-center hover:bg-gray-800 cursor-pointer transition-colors"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="white"
                                    className="w-5 h-5"
                                >
                                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                                </svg>
                            </a>

                            {/* Facebook */}
                            <a
                                href="https://www.facebook.com/share/1BNavfusWV/?mibextid=wwXIfr"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 cursor-pointer transition-colors"
                            >
                                <Facebook className="w-5 h-5 text-white" />
                            </a>
                        </div>
                    </div>

                </div>

                {/* Bottom bar */}
                <div className="border-t border-gray-700 pt-8 text-center">
                    <p className="text-gray-400">&copy; 2025 TeeChaa. All rights reserved.</p>
                    <p className="text-sm mt-2 text-gray-500">
                        Built with passion for students around the world.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
